// Должен соответствовать projectName
export const UNIQUE_CONFIG_KEY = 'commercial-filters-frontend';
